<template>
  <div class="section section5 bg s-c-cloud-live">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>云上直播
      <!-- <small>T: 背景图片暂时未做</small> -->
      <a href="####" class="tit-more more-link" @click.prevent="more()">更多</a>
    </h2>
    <div class="subnav">
      <ul class="navbox">
        <li :class="{active: selected === 'zhibohudong'}">
          <a @click.stop="onQueryData('zhibohudong')" href="javascript:;" class="fs-rem28">
            直播互动
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'zhihuichangjing'}">
          <a @click.stop="onQueryData('zhihuichangjing')" href="javascript:;" class="fs-rem28">
            智慧场景
            <i class="hr"></i>
          </a>
        </li>
        <li>
          <a @click.prevent="onQueryData('more')" href="javascript:;" class="c-blue fs-rem28">更多</a>
        </li>
      </ul>
    </div>
    <div class="w1200">
      <div class="sec5-list">
        <div class="swiper-container swiper2">
          <div class="swiper-wrapper" style="transition-duration: 0ms;">
            <div v-for="(video, index) in videos" :key="`video${index}`" class="swiper-slide lst-item "
              :data-swiper-slide-index="index">
              <a :href="video.url" class="lst-img">
                <div :style="`background-image:url(${formatImg(video.img)});`" class="cover-img flex flex-direction justify-center align-center">
                  <div class="player"></div>
                </div>
                <div class="text-white bottom-txt">
                  <div class=" bottom-title">{{video.title}}</div>
                  <div class="bottom-time">{{video.createTime}}</div>
                </div>
              </a>
              <!-- <a :href="video.url" class="lst-img">
                <img :src="formatImg(video.img)" class="img" />
              </a> -->
            </div>

          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
        <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide"></div>
        <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide"></div>
        <!-- <ul class="list-box">
          <li class="lst-item">
            <a href="####" class="lst-img">
              <img src="../../assets/_other/_img1.png" class="img" />
            </a>
          </li>
          <li class="lst-item">
            <a href="####" class="lst-img">
              <img src="../../assets/_other/_img1.png" class="img" />
            </a>
          </li>
          <li class="lst-item">
            <a href="####" class="lst-img">
              <img src="../../assets/_other/_img1.png" class="img" />
            </a>
          </li>
          <li class="lst-item">
            <a href="####" class="lst-img">
              <img src="../../assets/_other/_img1.png" class="img" />
            </a>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
  <!-- /云上直播 -->
</template>

<script>
  import Swiper from 'swiper';
  import {
    formatImgSrc
  } from '@/utils/format';

  import {
    queryPlatformVideos
  } from '@/api/main';
  import GetStaticIndexMixin from '@/mixins/GetStaticIndex.mixin.js'
  import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'
  export default {
    mixins: [GetStaticIndexMixin],
    name: 'LiveCloud',
    props: {
      msg: String,
    },
    data() {
      return {
        videos: [],
        selected: 'zhibohudong',
      }
    },
    mounted() {


    },
    methods: {
      p_init() {
        this.initData('yunshangzhibo')
        this._queryPlatformVideos();
        // const vlen = this.videos.length;
        // const slidesPerView = vlen < 4 ? vlen : 4;
        new Swiper('.swiper2', {
          loop: true,
          slidesPerView: 'auto',
          spaceBetween:10,
          initialSlide: 0,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      },
      resetData() {
        this.videos = [];
      },
      more() {
        console.log("more")
        this.$router.push('/scene')
      },
      onQueryData(tid) {
        if (tid === 'more') {
          this.more()
          return
        }
        this.resetData();
        this.selected = tid;
        this._queryPlatformVideos();
      },
      formatImg(img) {
        console.log('img------')
        return formatImgSrc(img)
      },
      formatData(list = []) {
        list.forEach(element => {
          element.cover = formatImgSrc(element.cover);
          return element;
        });
        return list;
      },
      _queryPlatformVideos() {
        // this.$http.get(queryPlatformVideos()).then((res) => {
        //   console.log(res, '>queryPlatformVideos');
        //   this.videos = this.formatData(res.data);
        //   const vlen = this.videos.length;
        //   const slidesPerView = vlen < 4 ? vlen : 4;
        //   new Swiper('.swiper2', {
        //     loop: true,
        //     slidesPerView,
        //     initialSlide :0,
        //     observer:true, //修改swiper自己或子元素时，自动初始化swiper
        //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //     navigation: {
        //       nextEl: '.swiper-button-next',
        //       prevEl: '.swiper-button-prev',
        //     },
        //   });
        // });
        this.videos = this.StaticIndexs[this.selected];
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import url(./LiveCloud.css);

  .cover-img {
    float: left;
    width: 1.7rem;
    height: 2.6rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    /* margin-right: .2rem; */
  }

  .player {
  	background-image: url(../../assets/video/player-btn.png);
  	width: 48px;
  	height: 48px;
  	background-repeat: no-repeat;
  	background-size: 100% 100%;
  	-moz-background-size: 100% 100%;
  }

  .bottom-txt {
    position: fixed;
    bottom: 10px;
    /* left: 0; */
  }
  .bottom-title{
    width: 1.5rem;
    height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin: 0 5px 0 10px;
    font-size: 14px;
  }
  .bottom-time{
    width: 1.6rem;
    height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin: 0 5px 0 10px;
    font-size: 14px;
  }
</style>
